import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeFormat'
})
export class TimeFormatPipe implements PipeTransform {

  transform(value: unknown): unknown {
    const time = Number(value);

    const minutesOK = Math.floor(time / 60);
    const seconds = time - minutesOK * 60;
    const secondsOK = Math.floor(seconds);
    const milliseconds = seconds - secondsOK;
    const millisecondsOK = Math.floor(milliseconds * 100);

    return ('0' + minutesOK).slice(-2) + ':' + ('0' + secondsOK).slice(-2) + ':' + ('0' + millisecondsOK).slice(-2);
  }

}
